function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "fill"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.15,12.231l-1.6,1.57-1.7-1.659a.5.5,0,1,0-.7.715l2.045,2a.5.5,0,0,0,.7,0l1.955-1.911a.5.5,0,1,0-.7-.715Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.894.142a.5.5,0,0,0-.7,0l-2.045,2a.5.5,0,1,0,.7.715L7.545,1.2l1.6,1.569a.5.5,0,1,0,.7-.714Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.849,5.142a.5.5,0,0,0-.707.008L.142,7.2a.5.5,0,0,0,0,.7L2.053,9.85a.5.5,0,0,0,.715-.7L1.2,7.545l1.658-1.7A.5.5,0,0,0,2.849,5.142Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.857,7.2l-2-2.045a.5.5,0,1,0-.715.7l1.658,1.7-1.569,1.6a.5.5,0,0,0,.715.7l1.911-1.956a.5.5,0,0,0,0-.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5,9.635a.455.455,0,0,0-.455.454v1.457a.455.455,0,0,0,.91,0V10.089A.455.455,0,0,0,7.5,9.635Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.91,7.046H3.455a.454.454,0,1,0,0,.908H4.91a.454.454,0,1,0,0-.908Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5,3a.455.455,0,0,0-.455.454V4.91a.455.455,0,0,0,.91,0V3.454A.455.455,0,0,0,7.5,3Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.545,7.046H10.09a.454.454,0,1,0,0,.908h1.455a.454.454,0,1,0,0-.908Z"
}));

function SvgIconMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMove);
export default __webpack_public_path__ + "static/media/icon_move.194dacfe.svg";
export { ForwardRef as ReactComponent };